// extracted by mini-css-extract-plugin
export default {"hideScrollBar":"JI7i3","dragRailOuterContainer":"u1Kqx","dragRailInnerContainer":"tXlkR","grabbing":"NDvRx"};